module.exports = __webpack_public_path__ + "static/media/bet-white-2.83ee143a.png";